import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
export const FrameIcon = ({ color, ...props }) => {
    const theme = useTheme();
    return (_jsxs("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", ...props, children: [_jsx("rect", { width: "18", height: "18", fill: color ?? theme.colors.grey90 }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2 8.8L6 13.6V4L13.2 8.8Z", fill: "#FAFAFA", stroke: "#FAFAFA", strokeLinecap: "round", strokeLinejoin: "round" })] }));
};
//# sourceMappingURL=frame_icon.js.map